import { worksFirstCss } from '../surface';

import type { ArmSpec } from '../armRegistry';

export const worksToTheTop: ArmSpec = {
  stamp: (ctx) => ({
    render_state: ctx.cards().length > 0 ? 'rendered' : 'fallback',
  }),

  onReady: (ctx) => {
    if (ctx.cards().length === 0) return;

    ctx.injectStyles(worksFirstCss(ctx.scope));
  },
};
